<template>
  <el-dialog
    :title="$t('equipment.prepayFreight')"
    custom-class="MyDialog"
    :visible.sync="paymentFeesDialogVisible"
    :close-on-click-modal="false"
    @close="closePaymentFeesDialog"
    width="1000px"
  >
  <div>
    <div class="purchase-fees-info">
      <div class="textOne">
        <span>{{ $t('purchasing.purchaseNo') }}：{{ payData.orderNo }}</span>
        <span>{{ $t('purchasing.orderTime') }}：{{ payData.orderCreateTime }}</span>
      </div>
      <div class="textTwo">
        <span>{{ $t('purchasing.purchaseQtyLabel') }}{{ payData.buyNum }}{{ $t('equipment.unitTai') }}</span>
        <span>{{ $t('purchasing.purchaseAmountLabel') }}<span :style="{ color: 'red' }">{{payData.orderAmount}}</span>
        </span>
        <span>{{ $t('purchasing.paidAmountLabel') }}<span :style="{ color: 'red' }">{{payData.receivedAmount}}</span>
        </span>
      </div>
      <div class="programme-box">
        <p class="programme-title">{{ $t('equipment.freightPlan') }}</p>
        <ul class="programme-ul">
          <li class="programme-1">{{ $t('equipment.plan1FreightCollect') }}<span class="programme-price">{{payData.freightOriginalAmount}}{{ $t('purchasing.yuan') }}</span>{{ $t('equipment.plan1FreightTip') }}</li>
          <li>{{ $t('equipment.plan2FreightPrepay') }}<span class="programme-price">{{payData.freightAmount}}{{ $t('purchasing.yuan') }}</span>
            {{ $t('equipment.plan2FreightTip', { amount: payData.freightOriginalAmount }) }}
          </li>
        </ul>
      </div>
    </div>
    <div class="charge-table">
      <MyTable
        :titleData="titleData1"
        :tableData="tableData1"
        :index="true"
        :indexMethod="indexMethod"
      ></MyTable>
    </div>
    <div class="fees-tips-wrap">
      <p class="action-title">{{ $t('equipment.freightOrderTip') }}</p>
      <ul class="rules-ul">
        <li>{{ $t('equipment.freightRule1') }}</li>
        <li>{{ $t('equipment.freightRule2') }}</li>
        <li>{{ $t('equipment.freightRule3') }}</li>
      </ul>
    </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button  @click="closePaymentFeesDialog">{{ $t('app.cancel') }}</el-button>
      <el-button type="primary" @click="onlyOrderPay">{{ $t('equipment.payFreightCollect') }}</el-button>
      <el-button type="primary" @click="confirmButton">{{ $t('equipment.payFreightPrepay') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryLadingOrderFreight, ladingDispatch, saveLadingFreight } from "@/api/AccountInterface";
import { resolveFormI18n, resolveTitleDataI18n } from "@/i18n/formI18n";
import MyTable from "@/components/table.vue";

export default {
  computed: {
    searchFormI18n() {
      return resolveFormI18n(this.searchForm, 'common', this.$t.bind(this));
    },
    titleDataI18n() {
      return resolveTitleDataI18n(this.titleData, 'common', this.$t.bind(this));
    },
  },

  data() {
    return {
      paymentFeesDialogVisible: false,
      titleData1: [
        {
          label: this.$t('purchasing.chargeItem'),
          prop: "itemName",
          key: "itemName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('purchasing.unitPrice'),
          prop: "price",
          key: "price",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('purchasing.quantity'),
          prop: "buyNum",
          key: "buyNum",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('purchasing.amount'),
          prop: "originalAmount",
          key: "originalAmount",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('purchasing.discount'),
          prop: "rateName",
          key: "rateName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: this.$t('equipment.amountAfterDiscount'),
          prop: "amount",
          key: "amount",
          align: "center"
          // fixed: 'left',
        },
      ],
      tableData1: [],
      tableItems: [],
      payData: {},
    }
  },
  props: {
    showLadingFreightOrSave: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String|Number,
      default: '',
    }
  },
  components: {
    MyTable,
  },
  watch: {
    showLadingFreightOrSave: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getOrderFreight();
        }
      },
      immediate: true
    },
  },
  mounted() {
    
  },
  methods: {
    getOrderFreight() {
      queryLadingOrderFreight({ladingNo: this.orderNo}).then(res => {
        if(res.code === 0) {
          this.payData = res.data;
          if (res.data.isShippingFree) {
            // 直接调用发货接口
            this.handleLadingDispatch();
          } else {
            // 弹框类型：1：运费弹框，2：支付弹框
            if (res.data.dialogType == 2) {
              this.paymentFeesDialogVisible = false;
              this.$emit('ladingYushouyunfeiSuccess');
              return;
            }
            this.paymentFeesDialogVisible = true;
            this.tableItems = res.data.items;
            let tableDataArr = JSON.parse(JSON.stringify(this.tableItems));
            tableDataArr.map(item => {
              if (item.itemName == this.$t('app.auto_302_f5bb943f')) {
                item['price'] = '';
                item['buyNum'] = '';
              }
            })
            this.tableData1 = tableDataArr;
          }
        } else {
          this.payData = {};
          this.tableItems = [];
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.auto_303_c3435521'));
        }
      })
    },
    closePaymentFeesDialog() {
      this.paymentFeesDialogVisible = false;
      this.$emit('closePaymentFeesDialog');
    },
    indexMethod(index) {
      return index + 1;
    },
    handleLadingDispatch() {
      ladingDispatch({ladingNo: this.orderNo}).then(ret => {
        if (ret.code === 0) {
          this.$message.success(this.$t('app.auto_304_52a4dfe7'));
          this.paymentFeesDialogVisible = false;
          this.$emit('ladingYunfeidaofuSuccess');
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_305_69f78632'));
        }
      })
    },
    onlyOrderPay() {
      saveLadingFreight({
        ladingNo: this.orderNo,
        items: [],
      }).then(ret => {
        if (ret.code === 0) {
          this.handleLadingDispatch();
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_306_24dad104'));
        }
      })
    },
    confirmButton() {
      saveLadingFreight({
        ladingNo: this.orderNo,
        items: this.tableItems,
      }).then(ret => {
      if (ret.code === 0) {
        this.paymentFeesDialogVisible = false;
        this.$emit('ladingYushouyunfeiSuccess');
      } else {
        this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_307_d9629eda'));
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.purchase-fees-info {
  color: #4A83E8;
  background: rgb(232, 243, 254);
  width: 100%;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.programme-box {
  margin-top: 10px;
  margin-left: 50px;
  padding-bottom: 15px;
  color: #1890ff;
  .programme-title {
    font-weight: 500;
  }
  .programme-price {
    color: rgba(224, 58, 50, 1);
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .programme-ul {
    margin-top: 10px;
    margin-bottom: 0;
    .programme-1 {
      margin-bottom: 10px;
    }
  }
}

.fees-tips-wrap {
  margin-top: 20px;
  margin-bottom: 10px;
  .action-title {
    color: #1890ff;
    font-size: 14px;
  }
  .rules-ul {
    margin-top: 20px;
    li {
      color: #1890ff;
      font-size: 14px;
    }
  }
}
</style>
